// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"external-content_wrapper__UlBsb"};